import { render } from "./CourseDetails.vue?vue&type=template&id=726ecbc7&scoped=true"
import script from "./CourseDetails.vue?vue&type=script&lang=js"
export * from "./CourseDetails.vue?vue&type=script&lang=js"

import "./CourseDetails.vue?vue&type=style&index=0&id=726ecbc7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726ecbc7"]])

export default __exports__